module.exports = __webpack_public_path__ + "media/images/bg_voice_mv_pc-ebe01ce26fb5740eaf12df29d3bad6e8.jpg";